export default __webpack_public_path__ + "static/media/Blue and silver Christmas wreath.4a50a110.jpg";